import React from 'react';
import Modal from '../../../../../../../components/Modal/Modal';
import Tag from '../../../../../../../components/tag/Tag/Tag';
import { openNewWindow, setDetailPageUrl } from '../../../../../../../lib/common';
import { TAG_HISTORY_URL_PATH } from '../../../../../../../constants/service/common/urlConstants';
import { RelatedTagModalStyle } from './style';
import { useRelatedTagList } from './useRelatedTagList';

interface RelatedTagModalProps {
  tagId: number;
  onClose: () => void;
}

const RelatedTagModal = (props: RelatedTagModalProps) => {
  const { tagId, onClose } = props;
  const tagList = useRelatedTagList(tagId);

  return (
    <Modal title="태그 보기" isOpen={true} width={350} height={350} isFooter={false} onOk={onClose} onClose={onClose}>
      <RelatedTagModalStyle>
        {tagList?.map((item) => (
          <Tag
            key={item.id}
            text={item.name}
            onClick={() => openNewWindow(setDetailPageUrl(TAG_HISTORY_URL_PATH, item.id))}
          />
        ))}
      </RelatedTagModalStyle>
    </Modal>
  );
};

export default RelatedTagModal;
